const request = require('request-promise-native')
// 權限要做好控管, 這裡對資安來說非常重要
let jwt_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFrb24iLCJlbWFpbCI6ImFrb244MjVAaG90bWFpbC5jb20iLCJleHAiOjIyMTIzMTMwMTIsImlhdCI6MTU4MTU5MzAxMn0._BY5dHcbFyde75QynpdqyMCgMCuUBRVRkyp1cbPAHUo"
//let ce_uri = "https://ce-backend.nctu.me"
let ce_uri = "https://ce-backend.cloud-empowering.com"
// ce_uri = "https://f151-2001-b011-3816-1849-ddf1-f3f0-2116-59a4.ngrok-free.app"

// ce_uri = "http://192.168.1.218:3000"

const CeApi = function(whichService) {
	this.postLineUserEmail = async function (line_user_id, channel_id, email, phone, display_name) {
		let body = {
			line_user_id,
			channel_id,
			email,
			phone,
			display_name
		}
		var options = {
			uri: `${ce_uri}/api/v1/ce/set_email`,
			//body: body,
			headers: { AUTHORIZATION: jwt_token },
			form: body,
			method: "POST",
			json: true // Automatically parses the JSON string in the response
		}

		try {
			let result = await request(options)

			return result
		} catch (err) {
			throw new Error(err)
		}
	}

	this.putLineUserEmail = async function (line_user_id, channel_id, email, phone, display_name) {
		let body = {
			line_user_id,
			channel_id,
			email,
			phone,
			display_name
		}
		var options = {
			uri: `${ce_uri}/api/v1/ce/set_email`,
			//body: body,
			headers: { AUTHORIZATION: jwt_token },
			form: body,
			method: "PUT",
			json: true // Automatically parses the JSON string in the response
		}

		try {
			// return {}
			let result = await request(options)

			return result
		} catch (err) {
			throw new Error(err)
		}
	}

	this.getUserByLineId = async function (line_user_id, channel_id) {
		let qs = {
			line_user_id,
			channel_id
		}
		var options = {
			uri: `${ce_uri}/api/v1/ce/get_user_by_line_id`,
			//body: body,
			headers: { AUTHORIZATION: jwt_token },
			qs: qs,
			method: "GET",
			json: true // Automatically parses the JSON string in the response
		}

		try {
			//return { email: "ttttt@gmail.com" }
			let result = await request(options)

			return result
		} catch (err) {
			throw new Error(err)
		}
	}
}

export default new CeApi()


// WEBPACK FOOTER //
// ./src/lib/ce_api.js